function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMerged = function SvgMerged(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    fillRule: "evenodd",
    d: "M9.487 3.71a.75.75 0 0 1 .75.75v5.027a.75.75 0 0 1-.75.75H4.458a.75.75 0 0 1 0-1.5h4.279V4.46a.75.75 0 0 1 .75-.75m4.278 10.805a.75.75 0 0 1 .75-.75h5.028a.75.75 0 0 1 0 1.5h-4.278v4.278a.75.75 0 0 1-1.5 0zm4.099-8.379a.75.75 0 0 1 0 1.06L7.197 17.863a.75.75 0 0 1-1.06-1.06L16.804 6.136a.75.75 0 0 1 1.06 0",
    clipRule: "evenodd"
  }));
};
export default SvgMerged;